import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './redux/store';
import { Provider } from "react-redux";
import { index } from "./i18n/index"
import { HelmetProvider } from "react-helmet-async";

// ─── Suppress ResizeObserver loop error from CRA dev overlay ──────────────────
// CRA's error overlay registers via addEventListener('error') internally.
// Using capture phase + stopImmediatePropagation() blocks it before CRA sees it.
const suppressResizeObserverError = (e) => {
  if (
    e.message &&
    e.message.includes('ResizeObserver loop')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
};
window.addEventListener('error', suppressResizeObserverError, true);
// Also patch window.onerror as a fallback
window.onerror = function (message) {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) return true;
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
